import { CitationData, CitationGeneratorAction, UserOpenedInplaceCreateForm } from '../types';
import * as actionNames from '../types/names';

export function toggleCitationGeneratorEditModal(
  open: boolean,
  editFormDefaultValuse?: CitationData,
  index?: number
): CitationGeneratorAction {
  return {
    type: actionNames.EDIT_MODAL_TOGGLE,
    payload: { open, editFormDefaultValuse, index },
  };
}

export function addCitationToSearchResults(payload: any): CitationGeneratorAction {
  return { type: actionNames.ADD_CITATIONS_TO_SEARCH_RESULT, payload };
}

export function changeSearchType(payload: any): CitationGeneratorAction {
  return { type: actionNames.CHANGED_CITATION_SOURCE, payload };
}

export function setSearchQuery(searchQuery: string): CitationGeneratorAction {
  return { type: actionNames.SetSearchQuery, payload: searchQuery };
}

export function setBibSearchQuery(searchQuery: string): CitationGeneratorAction {
  return { type: actionNames.USER_SEARCHED_QUERY, payload: searchQuery };
}

export function setLoadingResults(isLoadingResults: boolean): CitationGeneratorAction {
  return { type: actionNames.SetLoadingResults, payload: isLoadingResults };
}

export function setIsLastPage(isLastPage: boolean): CitationGeneratorAction {
  return { type: actionNames.SetIsLastPage, payload: isLastPage };
}

export function incrementPageNo(isSetToDefault?: boolean): CitationGeneratorAction {
  return { type: actionNames.IncrementPageNo, payload: isSetToDefault };
}

export function restoreToDefaultState(): CitationGeneratorAction {
  return { type: actionNames.RestoreToDefaultState };
}

export function toggleInplaceCreateForm(openForm: boolean): UserOpenedInplaceCreateForm {
  return { type: actionNames.OpenInplaceCreateForm, payload: openForm };
}

export function startSearchMode(): CitationGeneratorAction {
  return { type: actionNames.StartSearchMode };
}

export function stopSearchMode(): CitationGeneratorAction {
  return { type: actionNames.StopSearchMode };
}
